import React, { useRef } from "react";
import { useAllDoctors } from "../hooks/useDoctors";
import { Link } from "react-router-dom";
import { hospitalNameToSlug } from "../utils/hospitalUtils";
import StarRating from "./StarRating";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import SwiperCore from "swiper";
import { FreeMode, Autoplay, Navigation } from "swiper/modules";

SwiperCore.use([FreeMode, Autoplay, Navigation]);

const AllDoctorsCarousel = () => {
  const { doctors: bestDoctors, loading } = useAllDoctors();
  const swiperRef = useRef(null);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-xl text-blue-600">Loading doctors...</div>
      </div>
    );
  }

  return (
    <section className="container mx-auto px-4 py-16">
      <h2 className="text-4xl font-bold text-center mb-12">
        <span className="text-[#1976f2]">Best Doctors</span> From Around The World

      </h2>

      <div className="overflow-hidden relative">
        <Swiper
          ref={swiperRef}
          slidesPerView={1}
          spaceBetween={16}
          loop={true}
          freeMode={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          speed={1000}
          grabCursor={true}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }}
          className="w-full"
        >
          {[...bestDoctors, ...bestDoctors].map((doctor, index) => (
            <SwiperSlide key={`${doctor.id}-${index}`}>
              <div className="transition-transform duration-300 ease-in-out transform">
                <Link
                  to={`/doctor-details/${doctor.id}`}
                  className="block"
                >
                  <div className="w-full aspect-[4/3] rounded-lg overflow-hidden">
                    <img 
                      src={doctor.image} 
                      alt={doctor.name} 
                      className="w-full h-full object-contain bg-gray-50"
                    />
                  </div>
                  <div className="mt-3 text-center">
                    <h3
                      className="text-2xl font-semibold text-gray-600 truncate"
                      title={doctor.name}
                  >
                    {doctor.name}
                    </h3>
                    {doctor.rating && (
                      <div className="flex justify-center mt-2">
                        <StarRating 
                          rating={parseFloat(doctor.rating)} 
                          size="small" 
                          showRating={true}
                        />
                      </div>
                    )}
                    <p className="text-md text-black-600 mt-1">
                      {doctor.specialty} | {doctor.experience}
                    </p>
                    <p className="text-md text-black-600 mt-1">
                    {doctor.hospital}
                    </p>
                  </div>
                  </Link>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Navigation Buttons */}
      <div className="flex justify-center gap-4 mt-10">
        <button
            onClick={() => swiperRef.current?.swiper.slidePrev()}
          aria-label="Previous"
          className="w-12 h-12 rounded-full flex items-center justify-center bg-[#1976f2] hover:bg-blue-700 text-white transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
            onClick={() => swiperRef.current?.swiper.slideNext()}
          aria-label="Next"
          className="w-12 h-12 rounded-full flex items-center justify-center bg-[#1976f2] hover:bg-blue-700 text-white transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
        </div>
      </div>
    </section>
  );
};

export default AllDoctorsCarousel;
